module.exports = __webpack_public_path__ + "c724f0da528a6ed218719118787dcc6f.MP3";